<template>
  <v-app>
    <v-app-bar
      app
      color="lime"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />
        <v-toolbar-title>Reglage</v-toolbar-title>
      </div>

      <v-spacer></v-spacer>
      <Auth />
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import Auth from '@/components/Auth.vue'

export default {
  name: 'App',
  components: {
    Auth
  }
}
</script>